import React from "react";

import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./follows.scss";

interface FooterInterface {
  nombreCategoria: string;
  referenciaSubcategorias: {
    titulo: string;
    link: string;
    slug: string;
    nombreSubcategoria: string;
    tipoCampo: string;
  }[];
}

const Follows = (props: {
  query: FooterInterface;
  inverse?: boolean;
  noTitle?: boolean;
}) => {
  const { query, inverse = false, noTitle = false } = props;

  const drawSocialIcons = (type: boolean, value: any) => {
    if (type) {
      if (value.nombreSubcategoria.includes("1")) {
        return value.nombreSubcategoria.replace("1", "");
      } else {
        return value.nombreSubcategoria.concat("", "1");
      }
    }

    return value.nombreSubcategoria;
  };

  return (
    <div className="m-follows">
      {!noTitle && <span>{query.nombreCategoria}</span>}
      <ul>
        {query.referenciaSubcategorias.map((val, key) => (
          <li key={`followItem-${key}`} className={`gtm${normalizeTwoWords(val.titulo)}`}>
            <a
              href={val.link}
              className={`gtm${normalizeTwoWords(val.titulo)}`}
              target="_blank"
              rel="noreferrer"
            >
              <i
                className={`gtm${normalizeTwoWords(
                  val.titulo
                )} ${drawSocialIcons(inverse, val)}`}
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Follows;
